<template>
 <v-dialog
        v-model="showDialog"
        max-width="500"
        persistent
        class="confirm-dialog flex-none"
    >
        <template v-slot:activator="{ on }">
                <v-btn
                    v-if="alternativeBtn"
                    v-on="on"
                    v-bind="$attrs"
                    :disabled="disabled"
                    :loading="loading"
                    :class="btnClass"
                    :block="block"
                >
                    {{ btnText }}
                </v-btn>
                <v-btn
                    v-if="!alternativeBtn"
                    v-on="on"
                    @click="show()"
                    v-bind="$attrs"
                    :disabled="disabled"
                    :loading="loading"
                    text
                    icon
                    :class="btnClass"
                >
                    <v-icon v-bind="$attrs">{{ alternativeBtnIcon }}</v-icon>
                </v-btn>
        </template>
        <v-card>
            <v-card-title
                class="headline"
                primary-title
            >
                {{ dialogTitle }}
            </v-card-title>
            <v-card-text>
                <div pt-4 pb-4>
                    {{ dialogText }}
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="warning"
                    outlined
                    @click="abort"
                    :disabled="loading"
                >
                    {{ abortText }}
                </v-btn>
                <v-btn
                    outlined
                    class="success"
                    pl-0 pr-0
                    @click="submit"
                    :loading="loading"
                    :disabled="loading"
                >
                    {{ submitText }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name: 'ConfirmationDialog',
    props: [
        'alternativeBtn',
        'alternativeBtnIcon',
        'loading',
        'btnText',
        'submitText',
        'abortText',
        'dialogTitle',
        'dialogText',
        'btnClass',
        'disabled',
        'block',
    ],
    data() {
        return {
            showDialog: false,
        };
    },
    methods: {
        submit() {
            this.$emit('submit');
            this.showDialog = false;
        },
        abort() {
            this.$emit('abort');
            this.showDialog = false;
        },
    },
};

</script>
<style scoped lang="scss">
</style>
